// extracted by mini-css-extract-plugin
export var root = "cycle-page-module--root--wcSWx";
export var titleLink = "cycle-page-module--titleLink--fAwq-";